import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-l1-prod-order",
  "use": "icon-soc-l1-prod-order-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" fill=\"none\" id=\"icon-soc-l1-prod-order\">\n  <!-- ?????????? + ??? -->\n  <g fill=\"none\" stroke=\"currentColor\" stroke-width=\"64\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\n    <path d=\"M256 192h320l192 192v448c0 35-29 64-64 64H256c-35 0-64-29-64-64V256c0-35 29-64 64-64z\" />\n    <path d=\"M576 192v192h192\" />\n    <path d=\"M352 544h288M352 672h192\" />\n    <path d=\"M800 320v448\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-l1-prod-order.svg
// module id = uQiQ
// module chunks = 492